import {
  headline,
  text,
  field,
  button,
  spacer,
  rank,
} from '@components/Widgets/_contentItems/all'
import { settings, styling } from '@components/Widgets/Templates/Base/_base'
import themes from '@components/Widgets/Templates/Themes/all'
import { position, type } from '@meta/widget/options.js'
import { typeTag, tag } from '@meta/widget/templates.js'

const info = {
  name: 'Customer Feedback',
  templateID: '11',
  description:
    'Collect valuable insights with the "Customer Feedback" widget. This simple yet effective tool allows users to provide feedback on their experience, helping you improve your services and products',
  tags: [typeTag.FLYOUT, tag.FEEDBACK],
}

const json = {
  id: 67302523,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  theme: themes.ONVOCADO.theme,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = '#FFFFFF'
    customSettings.animation = 'zoom'
    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling }
    customStyling.backgroundColor = '#def2a0'
    return customStyling
  })(),
  steps: [
    {
      id: 'ytregdfht',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Your Opinion Matters to Us!'
          Object.assign(customHeadline.styling, {
            color: 'rgba(14, 40, 20, 1)',
            fontSize: '28px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            textAlign: 'left',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'How likely are you to recommend our [Product/Service] to a friend or colleague?'
          Object.assign(customText.styling, {
            color: 'rgba(14, 40, 20, 1)',
            fontSize: '17px',
            textAlign: 'left',
            fontFamily: 'Roboto',
          })
          return customText
        })(),
        (() => {
          const customRank = JSON.parse(JSON.stringify(rank))
          customRank.settings.type = 'star'
          customRank.settings.required = true
          customRank.settings.label = 'Opinion Rating'
          customRank.settings.count = 5
          customRank.styling.baseColor = 'rgba(251, 180, 2, 1)'
          return customRank
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'NEXT'
          customButton.settings.backBtn = false
          customButton.styling.backgroundColor = 'rgba(14, 40, 20, 1)'
          customButton.styling.borderColor = 'rgba(14, 40, 20, 1)'
          customButton.styling.color = 'rgba(248, 249, 232, 1)'
          return customButton
        })(),
      ],
    },
    {
      id: 'iberguoi3',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'What\'s the primary reason for your score?'
          Object.assign(customHeadline.styling, {
            color: 'rgba(14, 40, 20, 1)',
            textAlign: 'left',
            fontSize: '26px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'What aspects of our service led you to give us this rating?'
          Object.assign(customText.styling, {
            color: 'rgba(14, 40, 20, 1)',
            fontSize: '17px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Your message'
          customField.settings.type = 'text'
          customField.settings.label = 'Text Field'
          customField.settings.required = true
          Object.assign(customField.styling, {
            color: 'rgba(65, 65, 65, 1)',
            fontSize: '17px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(81, 81, 81, 1)',
            borderWidth: '0px',
            borderRadius: '0px',
            backgroundColor: 'rgba(248, 249, 232, 1)',
          })
          return customField
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'NEXT'
          customButton.styling.backgroundColor = 'rgba(14, 40, 20, 1)'
          customButton.styling.color = 'rgba(248, 249, 232, 1)'
          return customButton
        })(),
      ],
    },
    {
      id: 'ryetdsfgrt4',
      contentItems: [
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '20px'
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Thank you for taking the time to share your thoughts!'
          Object.assign(customHeadline.styling, {
            fontWeight: 'bold',
            fontSize: '26px',
          })
          return customHeadline
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '40px'
          return customSpacer
        })(),
      ],
    },
  ],
}

export { json, info }